export default __webpack_public_path__ + "static/garden_design23-aab108f31a0451d4e3341ce96402823a.webp";